<template>
  <div>
    <carousel
      id="customCarousel"
      ref="customCarousel"
      :autoplay="false"
      :loop="true"
      :per-page="1"
      :autoplayTimeout="10000"
      paginationPosition="top-overlay"
      paginationActiveColor="#8DB452"
      class="custom-carousel"
    >
      <slide v-if="verifyCurrently">
        <card
          class="custom-card-bg-color custom-shadow-card-header h-100"
          :style="`height: ${height}px !important;`"
        >
          <div class="row">
            <div class="col-12">
              <img
                class="chart-logo"
                src="/static/img/iconos/icono-color-clima-white.svg"
              />
              <span class="custom-color-text ml-2">
                <strong> {{ $t('common_words.climate') }} </strong>
              </span>
              <hr />
            </div>
          </div>
          <div
            class="row d-flex flex-wrap align-items-center justify-content-around"
          >
            <div class="col-1 my-0 py-0 px-0 mx-1 text-right">
              <img
                class="my-0 py-0"
                style="width: 70px"
                :src="`/static/img/iconos/partly-cloudy-day-white.svg`"
              />
            </div>
            <div class="col-5 col-sm-5 px-0">
              <div class="col-12 my-0 py-0 px-0 mx-2 text-left">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="currentWeatherSummary"
                >
                  <span
                    class="custom-color-text my-0 py-0 custom-prop-text"
                    style="font-size: 16px"
                  >
                    {{ truncateText(currentWeatherSummary) }}
                  </span>
                </el-tooltip>
              </div>
              <div class="col-12 my-0 py-0 px-0 mx-2 text-left">
                <span
                  class="first custom-color-text my-0 py-0 custom-prop-text"
                  style="font-size: 16px"
                >
                  {{ day }} - {{ currentDate }}
                </span>
              </div>
            </div>
            <div class="col-5 col-sm-5 px-0">
              <el-select
                v-model="idStation"
                filterable
                class="select-default mb-3 ml-0"
                :placeholder="`${$t('common_words.select2')}...`"
                @change="getDataClimateForecast"
              >
                <el-option
                  class="select-default"
                  :label="$t('common_words.actual_position')"
                  :value="0"
                >
                </el-option>
                <el-option
                  class="select-default"
                  v-for="(station, index) in stations"
                  :key="index"
                  :label="station.name"
                  :value="station.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div
            class="col-12 col-sm-12 mt-1 mb-1 d-flex flex-wrap justify-content-center align-items-center"
          >
            <span class="custom-color-text custom-font-size">
              <strong>{{ $t('common_words.actual_condition') }}</strong>
            </span>
          </div>
          <div class="row justify-content-center custom-margin">
            <div
              v-for="item in currentClimateItems"
              :key="item.key"
              class="col-6 col-lg-5 col-md-5 mb-3"
            >
              <div class="d-flex align-items-center justify-content-center">
                <img
                  class="climate-icon"
                  :src="item.icon"
                  :alt="$t(item.label)"
                />

                <div class="ml-2">
                  <div>
                    <span
                      class="custom-color-text custom-prop-text"
                      style="font-size: 15px"
                    >
                      {{ $t(item.label) }}
                    </span>
                  </div>

                  <div class="text-right">
                    <span
                      class="custom-color-text custom-prop-text custom-font-size"
                    >
                      {{ item.value }}{{ item.unit }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr
            style="
              background-color: rgba(255, 255, 255, 0.4);
              margin: 20px 0 20px 0;
            "
          />
          <div class="row justify-content-center custom-margin">
            <div
              v-for="item in currentExtraItems"
              :key="item.key"
              class="col-4 col-lg-4 mb-3"
            >
              <div class="d-flex align-items-center justify-content-center">
                <img
                  class="climate-icon2"
                  :src="item.icon"
                  :alt="$t(item.label)"
                />

                <div class="ml-1">
                  <div>
                    <span class="custom-color-text custom-prop-text">
                      {{ $t(item.label) }}
                    </span>
                  </div>

                  <div class="text-right">
                    <span
                      class="custom-color-text custom-prop-text custom-font-size"
                    >
                      {{ item.value }}{{ item.unit }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </card>
      </slide>
      <slide v-if="verifyDaily">
        <card
          class="custom-card-bg-color custom-shadow-card-header h-100"
          :style="`height: ${height}px !important;`"
        >
          <div class="row">
            <div class="col-12">
              <img
                class="chart-logo"
                src="/static/img/iconos/icono-color-clima-white.svg"
                alt=""
              />
              <span class="custom-color-text ml-2">
                <strong>{{ $t('common_words.climate') }}</strong>
              </span>
              <hr />
            </div>
          </div>
          <div class="d-flex flex-column justify-content-center h-80">
            <div class="row">
              <div class="col-12 text-center mb-1">
                <span class="custom-color-text custom-font-size">
                  <strong>{{ $t('climate.forecast_six_days') }}</strong>
                </span>
              </div>
            </div>
            <div class="row justify-content-center mb-1">
              <div class="col-12 col-md-8 col-lg-6">
                <div class="d-flex align-items-center justify-content-center">
                  <img
                    class="forecast-main-icon"
                    :src="tomorrowForecast.icon"
                    :alt="tomorrowForecast.summary"
                  />
                  <div class="ml-3">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="tomorrowForecast.summary"
                    >
                      <div
                        class="custom-color-text custom-prop-text forecast-summary"
                      >
                        {{ truncateText(tomorrowForecast.summary) }}
                      </div>
                    </el-tooltip>

                    <div class="custom-color-text custom-prop-text">
                      {{ tomorrowForecast.day }} -
                      {{ tomorrowForecast.date }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div
                v-for="item in tomorrowClimateItems"
                :key="item.key"
                class="col-6 col-md-5 col-lg-5 mb-3"
              >
                <div class="d-flex align-items-center justify-content-center">
                  <img
                    class="climate-icon"
                    :src="item.icon"
                    :alt="$t(item.label)"
                  />

                  <div class="ml-2">
                    <div>
                      <span
                        class="custom-color-text custom-prop-text"
                        style="font-size: 15px"
                      >
                        {{ $t(item.label) }}
                      </span>
                    </div>

                    <div class="text-right">
                      <span
                        class="custom-color-text custom-prop-text custom-font-size"
                      >
                        {{ item.value }}{{ item.unit }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr
              style="
                background-color: rgba(255, 255, 255, 0.4);
                margin: 15px 0 20px;
              "
            />
            <div class="row justify-content-center">
              <div
                v-for="day in forecastDays"
                :key="day.key"
                class="col-4 col-lg-2 mb-3"
              >
                <div class="forecast-card text-center">
                  <div class="custom-color-text custom-prop-text forecast-day">
                    <strong>{{ day.day }}</strong>
                  </div>

                  <el-tooltip class="item" effect="dark" :content="day.summary">
                    <img
                      class="forecast-day-icon"
                      :src="day.icon"
                      :alt="day.summary"
                    />
                  </el-tooltip>

                  <div
                    class="d-flex align-items-center justify-content-center mt-1"
                  >
                    <img
                      class="forecast-small-icon"
                      src="/static/img/iconos/temperatura-white.svg"
                      alt=""
                    />

                    <span
                      class="custom-color-text custom-prop-text forecast-card-value"
                    >
                      {{ day.temperature }}°C
                    </span>
                  </div>

                  <div
                    class="d-flex align-items-center justify-content-center mt-1"
                  >
                    <img
                      class="forecast-small-icon"
                      src="/static/img/iconos/lluvia-white.svg"
                      alt=""
                    />

                    <span
                      class="custom-color-text custom-prop-text forecast-card-value"
                    >
                      {{ day.rainProbability }}%
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </card>
      </slide>
      <slide v-else>
        <card
          class="custom-card-bg-color custom-shadow-card-header h-100"
          :style="`height: ${height}px !important;`"
        >
          <div class="row">
            <div class="col-12">
              <img
                class="chart-logo"
                src="/static/img/iconos/icono-color-clima-white.svg"
              />
              <span class="custom-color-text ml-2">
                <strong> {{ $t('common_words.climate') }} </strong>
              </span>
              <hr />
            </div>
          </div>
          <div
            class="row d-flex align-items-center justify-content-around h-80"
          >
            <div class="col-1 my-0 py-0 px-0 mx-1 text-right">
              <img
                class="my-0 py-0"
                style="width: 70px"
                :src="`/static/img/iconos/partly-cloudy-day-white.svg`"
              />
            </div>
            <div class="col-5 col-sm-5 px-0">
              <div class="col-12 my-0 py-0 px-0 mx-2 text-left">
                <el-tooltip class="item" effect="dark" :content="'---'">
                  <span
                    class="custom-color-text my-0 py-0 custom-prop-text"
                    style="font-size: 16px"
                  >
                    ---
                  </span>
                </el-tooltip>
              </div>
              <div class="col-12 my-0 py-0 px-0 mx-2 text-left">
                <span
                  class="first custom-color-text my-0 py-0 custom-prop-text"
                  style="font-size: 16px"
                >
                  ---
                </span>
              </div>
            </div>
            <div class="col-5 col-sm-5 px-0">
              <el-select
                filterable
                class="select-default mb-3 ml-0"
                :placeholder="`${$t('common_words.select2')}...`"
                v-model="idStation"
              >
                <el-option
                  class="select-default"
                  :label="$t('common_words.actual_position')"
                  :value="0"
                >
                </el-option>
                <el-option
                  class="select-default"
                  v-for="(station, index) in stations"
                  :key="index"
                  :label="station.name"
                  :value="station.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div
            class="col-12 col-sm-12 mt-1 mb-1 d-flex flex-wrap justify-content-center align-items-center"
          >
            <span class="custom-color-text custom-font-size my-1">
              <strong>{{ $t('common_words.actual_condition') }}</strong>
            </span>
          </div>
          <div class="row justify-content-center custom-margin">
            <div
              v-for="item in climateItems"
              :key="item.key"
              class="col-6 col-lg-5 col-md-5"
            >
              <div class="d-flex align-items-center justify-content-center">
                <img
                  class="climate-icon"
                  :src="item.icon"
                  :alt="$t(item.label)"
                />
                <div class="ml-2">
                  <div>
                    <span
                      class="custom-color-text custom-prop-text"
                      style="font-size: 15px"
                    >
                      <strong>{{ $t(item.label) }}</strong>
                    </span>
                  </div>

                  <div class="text-right">
                    <span
                      class="custom-color-text custom-prop-text custom-font-size"
                    >
                      {{ item.value }}{{ item.unit }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr
            style="
              background-color: rgba(255, 255, 255, 0.4);
              margin: 20px 0 20px 0;
            "
          />
          <div class="row justify-content-center custom-margin">
            <div
              v-for="item in extraItems"
              :key="item.key"
              class="col-4 col-lg-4 mb-3"
            >
              <div class="d-flex align-items-center justify-content-center">
                <img
                  class="climate-icon2"
                  :src="item.icon"
                  :alt="$t(item.label)"
                />
                <div class="ml-1">
                  <div>
                    <span class="custom-color-text custom-prop-text">
                      {{ $t(item.label) }}
                    </span>
                  </div>

                  <div class="text-right">
                    <span
                      class="custom-color-text custom-prop-text custom-font-size"
                    >
                      {{ item.value }}{{ item.unit }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </card>
      </slide>
    </carousel>
  </div>
</template>
<script>
import { Avatar, Card, Col, Row, Tooltip } from 'element-ui';
import Vue from 'vue';
import VueCarousel, { Carousel, Slide } from 'vue-carousel';
import moment from 'moment';
import MixinNumbers from 'src/util/mixinNumbers';
import mixinLocation from 'src/util/mixinLocation';
import SweetAlert from 'src/class/Alerts';
import axios from 'axios';
import { Axios } from 'src/class/Axios.js';
import i18n from 'src/i18n';

Vue.use(VueCarousel);

export default {
  name: 'ClimateCarousel',
  components: {
    [Avatar.name]: Avatar,
    [Card.name]: Card,
    [Col.name]: Col,
    [Row.name]: Row,
    [Tooltip.name]: Tooltip,
    Carousel,
    Slide,
  },
  props: {
    height: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      idStation: null,
      stations: [],
      rangeSlider: null,
      currently: [],
      currentDate: moment().format('DD/MM/YYYY'),
      currentTime: moment().format('hh:mm:ss'),
      currentYear: moment().format('YYYY'),
      tomorrowDate: moment().add(1, 'days').format('DD/MM/YYYY'),
      climateItems: [
        {
          key: 'temperature',
          label: 'climate.temperature',
          icon: '/static/img/iconos/temperatura-white.svg',
          value: '---',
          unit: '°C',
        },
        {
          key: 'humidity',
          label: 'climate.humidity',
          icon: '/static/img/iconos/humedad-white.svg',
          value: '---',
          unit: '%',
        },
        {
          key: 'precipitation',
          label: 'climate.precipitation',
          icon: '/static/img/iconos/rain-white.svg',
          value: '---',
          unit: ' mm/h',
        },
        {
          key: 'rainProbability',
          label: 'climate.rain_probability',
          icon: '/static/img/iconos/lluvia-white.svg',
          value: '---',
          unit: '%',
        },
      ],
      extraItems: [
        {
          key: 'wind',
          label: 'climate.wind',
          icon: '/static/img/iconos/viento-white.svg',
          value: '---',
          unit: ' Km/h',
        },
        {
          key: 'pressure',
          label: 'climate.pressure',
          icon: '/static/img/iconos/barometro-white.svg',
          value: '---',
          unit: ' mb',
        },
        {
          key: 'dew_point',
          label: 'climate.dew_point',
          icon: '/static/img/iconos/rocio-white.svg',
          value: '---',
          unit: '°C',
        },
        {
          key: 'cloud',
          label: 'climate.cloud',
          icon: '/static/img/iconos/cloudy-white.svg',
          value: '---',
          unit: '%',
        },
        {
          key: 'visibility',
          label: 'climate.visibility',
          icon: '/static/img/iconos/niebla-white.svg',
          value: '---',
          unit: ' Km',
        },
        {
          key: 'ozone',
          label: 'climate.ozone',
          icon: '/static/img/iconos/ozono-white.svg',
          value: '---',
          unit: ' U.D.',
        },
      ],
    };
  },
  mixins: [MixinNumbers, mixinLocation],
  computed: {
    currentDateCalendar() {
      return moment().locale(i18n.locale).format('LLLL');
    },
    currentDay() {
      return moment().locale(i18n.locale).format('dddd');
    },
    day() {
      return this.currentDay.charAt(0).toUpperCase() + this.currentDay.slice(1);
    },
    dayCards() {
      return this.currently.fullWeek ? this.currently.fullWeek.slice(2, 8) : [];
    },
    verifyCurrently() {
      return (
        this.currently &&
        this.currently.currently &&
        Object.keys(this.currently.currently).length > 0
      );
    },
    verifyDaily() {
      return (
        this.currently &&
        this.currently.daily &&
        Object.keys(this.currently.daily).length > 0
      );
    },
    currentWeather() {
      return this.verifyCurrently ? this.currently.currently : {};
    },
    currentWeatherIcon() {
      const icon = this.currentWeather.icon;

      return icon
        ? `/static/img/iconos/${icon}-white.svg`
        : '/static/img/iconos/partly-cloudy-day-white.svg';
    },
    currentWeatherSummary() {
      return this.currentWeather.summary || '---';
    },
    tomorrowWeather() {
      if (
        !this.verifyDaily ||
        !this.currently.daily.data ||
        !this.currently.daily.data[1]
      ) {
        return {};
      }

      return this.currently.daily.data[1];
    },

    tomorrowForecast() {
      const weather = this.tomorrowWeather;

      return {
        summary: weather.summary || '---',

        day:
          this.currently.fullWeek && this.currently.fullWeek[1]
            ? this.currently.fullWeek[1]
            : '---',

        date: this.tomorrowDate,

        icon: weather.icon
          ? `/static/img/iconos/${weather.icon}-white.svg`
          : '/static/img/iconos/partly-cloudy-day-white.svg',
      };
    },
    tomorrowClimateItems() {
      const weather = this.tomorrowWeather;

      return [
        {
          key: 'temperature',
          label: 'climate.temperature',
          icon: '/static/img/iconos/temperatura-white.svg',
          value: this.formatClimateValue(weather.temperatureMax, 1),
          unit: '°C',
        },
        {
          key: 'humidity',
          label: 'climate.humidity',
          icon: '/static/img/iconos/humedad-white.svg',
          value: this.formatPercentage(weather.humidity, 2),
          unit: '%',
        },
        {
          key: 'precipitation',
          label: 'climate.precipitation',
          icon: '/static/img/iconos/rain-white.svg',
          value: this.formatClimateValue(weather.precipIntensity, 2),
          unit: ' mm/h',
        },
        {
          key: 'rainProbability',
          label: 'climate.rain_probability',
          icon: '/static/img/iconos/lluvia-white.svg',
          value: this.formatPercentage(weather.precipProbability, 2),
          unit: '%',
        },
      ];
    },
    forecastDays() {
      if (
        !this.verifyDaily ||
        !this.currently.daily.data ||
        !this.currently.fullWeek
      ) {
        return [];
      }

      return this.currently.daily.data.slice(2, 8).map((weather, index) => ({
        key: `forecast-${index}`,

        day: this.currently.fullWeek[index + 2] || '---',

        summary: weather.summary || '---',

        icon: weather.icon
          ? `/static/img/iconos/${weather.icon}-white.svg`
          : '/static/img/iconos/partly-cloudy-day-white.svg',

        temperature: this.formatClimateValue(weather.temperatureMax, 1),

        rainProbability: this.formatPercentage(weather.precipProbability, 2),
      }));
    },
    currentClimateItems() {
      return [
        {
          key: 'temperature',
          label: 'climate.temperature',
          icon: '/static/img/iconos/temperatura-white.svg',
          value: this.formatClimateValue(this.currentWeather.temperature, 1),
          unit: '°C',
        },
        {
          key: 'humidity',
          label: 'climate.humidity',
          icon: '/static/img/iconos/humedad-white.svg',
          value: this.formatPercentage(this.currentWeather.humidity, 2),
          unit: '%',
        },
        {
          key: 'precipitation',
          label: 'climate.precipitation',
          icon: '/static/img/iconos/rain-white.svg',
          value: this.formatClimateValue(
            this.currentWeather.precipIntensity,
            2
          ),
          unit: ' mm/h',
        },
        {
          key: 'rainProbability',
          label: 'climate.rain_probability',
          icon: '/static/img/iconos/lluvia-white.svg',
          value: this.formatPercentage(
            this.currentWeather.precipProbability,
            2
          ),
          unit: '%',
        },
      ];
    },
    currentExtraItems() {
      return [
        {
          key: 'wind',
          label: 'climate.wind',
          icon: '/static/img/iconos/viento-white.svg',
          value: this.formatWindSpeed(this.currentWeather.windSpeed),
          unit: ' Km/h',
        },
        {
          key: 'pressure',
          label: 'climate.pressure',
          icon: '/static/img/iconos/barometro-white.svg',
          value: this.formatClimateValue(this.currentWeather.pressure, 2),
          unit: ' mb',
        },
        {
          key: 'dew_point',
          label: 'climate.dew_point',
          icon: '/static/img/iconos/rocio-white.svg',
          value: this.formatClimateValue(this.currentWeather.dewPoint, 2),
          unit: '°C',
        },
        {
          key: 'cloud',
          label: 'climate.cloud',
          icon: '/static/img/iconos/cloudy-white.svg',
          value: this.formatPercentage(this.currentWeather.cloudCover, 2),
          unit: '%',
        },
        {
          key: 'visibility',
          label: 'climate.visibility',
          icon: '/static/img/iconos/niebla-white.svg',
          value: this.formatClimateValue(this.currentWeather.visibility, 2),
          unit: ' Km',
        },
        {
          key: 'ozone',
          label: 'climate.ozone',
          icon: '/static/img/iconos/ozono-white.svg',
          value: this.formatClimateValue(this.currentWeather.ozone, 2),
          unit: ' U.D.',
        },
      ];
    },
  },
  methods: {
    handleRange(min, max) {
      this.rangeSlider = [min, max];
    },

    truncateText(text) {
      if (!text) return '---';
      if (text.length > 18) return text.substring(0, 18) + '...';

      return text;
    },

    formatClimateValue(value, decimals = 2) {
      if (
        value === null ||
        value === undefined ||
        value === '' ||
        Number.isNaN(Number(value))
      ) {
        return '---';
      }

      return this.roundNumber(Number(value), decimals);
    },

    formatPercentage(value, decimals = 2) {
      if (
        value === null ||
        value === undefined ||
        value === '' ||
        Number.isNaN(Number(value))
      ) {
        return '---';
      }

      return this.roundNumber(Number(value) * 100, decimals);
    },

    formatWindSpeed(value) {
      if (
        value === null ||
        value === undefined ||
        value === '' ||
        Number.isNaN(Number(value))
      ) {
        return '---';
      }

      return this.roundNumber(Number(value) * 3.6, 2);
    },

    setDataClimateForecast(idStation) {
      const baseUrl = 'weatherkitappleapi/getDataApi';
      const url =
        idStation === 0
          ? `${baseUrl}/${this.center.lat},${this.center.lng}`
          : `${baseUrl}/${idStation}`;

      Axios.getMasters(url)
        .then((response) => {
          this.currently = response.data.data;
          if (idStation !== 0) {
            this.center.lat = this.currently.latitude
              ? parseInt(this.currently.latitude)
              : this.center.lat;
            this.center.lng = this.currently.longitude
              ? parseInt(this.currently.longitude)
              : this.center.lng;
          }
          this.handleRange(
            this.currently.daily.data[0].temperatureMin,
            this.currently.daily.data[0].temperatureMax
          );
          this.climate = true;
          this.showClimate = true;
        })
        .catch((error) => {
          console.log(error);
          this.climate = true;
          this.showClimate = true;
        });
    },

    async getDataClimateForecast(idStation) {
      if (Object.keys(this.center).length === 0) {
        await this.getPosition();
      }

      this.idStation = idStation;
      this.setDataClimateForecast(idStation);
    },

    async getStations() {
      const response = await axios.get('auth/devices/stations/only/all');
      if (response.data) {
        this.stations = response.data.data;
        if (this.stations.length > 0) {
          await this.getDataClimateForecast(
            0,
            i18n.t('common_words.actual_pos')
          );
        } else {
          SweetAlert.warning(i18n.t('common_words.unavailable_stations'));
        }
      } else {
        SweetAlert.warning(error.response.data.message);
      }
    },
  },
  async created() {
    await this.getStations();
  },
};
</script>
<style scoped>
.first::first-letter {
  text-transform: capitalize !important;
}
.custom-card-bg-color {
  background-color: #33653b !important;
}
.custom-color-text {
  color: white !important;
}
.custom-text {
  font-size: 20px !important;
}
.custom-text1 {
  font-size: 12px !important;
  margin-left: 10px;
}
.custom-text-cards {
  font-size: 11px !important;
  color: white !important;
}
.icon-climate-actually {
  padding-top: 5px;
}
.custom-prop-text {
  font-family: 'Open Sans', sans-serif;
}
.custom-font-size {
  font-size: 18px;
}
.custom-font-size2 {
  font-size: 20px;
}
.custom-title-size {
  font-size: 30px;
}
.el-avatar {
  background: none;
}
.climate-icon {
  width: 45px;
}
.climate-icon2 {
  width: 40px;
}
@media (max-width: 1800px) {
  .custom-margin {
    margin: 25px 0 20px 0;
  }
}
.forecast-main-icon {
  width: 45px;
}
.forecast-summary {
  max-width: 220px;
  overflow: hidden;
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.forecast-card {
  width: 100%;
}
.forecast-day {
  min-height: 20px;
  font-size: 13px;
}
.forecast-day-icon {
  width: 50px;
}
.forecast-small-icon {
  width: 20px;
}
.forecast-card-value {
  margin-left: 4px;
  font-size: 12px;
}
@media (max-width: 991.98px) {
  .forecast-main-icon {
    width: 40px;
  }
  .forecast-summary {
    max-width: 180px;
  }
  .forecast-day-icon {
    width: 46px;
  }
}
@media (max-width: 575.98px) {
  .forecast-main-icon {
    width: 30px;
  }
  .forecast-summary {
    max-width: 150px;
    font-size: 14px;
  }
  .forecast-day {
    font-size: 11px;
  }
  .forecast-day-icon {
    width: 40px;
  }
  .forecast-small-icon {
    width: 17px;
  }
  .forecast-card-value {
    font-size: 10px;
  }
}
</style>
